import { Observable } from "rxjs";
import { combineEpics } from "redux-observable";

import st from "lib/utils/index";
import { AgentCooperationsRepository } from "lib/repositories/index";
import { createResourceInstance } from "modules/utils/index";

export const INITIALIZE_VIEW = "agents/SuppliersListView/INITIALIZE_VIEW";
export const DESTROY_VIEW = "agents/SuppliersListView/DESTROY_VIEW";
export const LOAD_RECORDS = "agents/SuppliersListView/LOAD_RECORDS";
export const FETCH_RECORDS = "agents/SuppliersListView/FETCH_RECORDS";
export const FETCH_RECORDS_START = "agents/SuppliersListView/FETCH_RECORDS_START";
export const FETCH_RECORDS_SUCCESS = "agents/SuppliersListView/FETCH_RECORDS_SUCCESS";
export const FETCH_RECORDS_FAILURE = "agents/SuppliersListView/FETCH_RECORDS_FAILURE";
export const CHANGE_PAGINATION = "agents/SuppliersListView/CHANGE_PAGINATION";
export const SET_PAGINATION = "agents/SuppliersListView/SET_PAGINATION";
export const SET_SEARCH = "agents/SuppliersListView/SET_SEARCH";

export const stateSelector = (state) => state.agents.SuppliersListView;

const recordsResource = createResourceInstance({
  LOAD: LOAD_RECORDS,
  FETCH: FETCH_RECORDS,
  FETCH_START: FETCH_RECORDS_START,
  FETCH_SUCCESS: FETCH_RECORDS_SUCCESS,
  FETCH_FAILURE: FETCH_RECORDS_FAILURE,
  stateSelector,
  stateKey: "records",
  getModel: ({ offset, limit, search }) => {
    const page = offset / limit + 1;
    const params = { role: "supplier", page, per: limit };
    if (search) params.search = search;
    return AgentCooperationsRepository.findAll(params);
  },
});

const limit = parseInt(localStorage.getItem("suppliersLimit"), 10) || 20;

const initialState = {
  records: recordsResource.initialState,
  offset: 0,
  limit: limit,
  search: "",
};

const reducers = {
  ...recordsResource.reducersMap,

  [INITIALIZE_VIEW]: () => initialState,

  [SET_PAGINATION]: (state, { offset = state.offset, limit = state.limit }) => ({
    ...state,
    offset,
    limit,
  }),

  [SET_SEARCH]: (state, { search }) => ({
    ...state,
    search,
    offset: 0,
  }),
};

const viewEpics = [
  ...recordsResource.epics,

  (actions$) => Observable.of(fetchRecords()),

  (actions$) => actions$.ofType(CHANGE_PAGINATION).map(({ offset, limit }) => setPagination({ offset, limit })),

  (actions$) => actions$.ofType(CHANGE_PAGINATION).debounceTime(300).mapTo(fetchRecords()),

  (actions$) => actions$.ofType(SET_SEARCH).debounceTime(400).mapTo(fetchRecords()),
];

const epics = [
  (actions$, store) =>
    actions$
      .ofType(INITIALIZE_VIEW)
      .concatMap(() => combineEpics(...viewEpics)(actions$, store).takeUntil(actions$.ofType(DESTROY_VIEW))),
];

export const { load: loadRecords, fetch: fetchRecords } = recordsResource.actions;

export function initializeView() {
  return { type: INITIALIZE_VIEW };
}

export function destroyView() {
  return { type: DESTROY_VIEW };
}

export function changePagination({ offset, limit }) {
  return { type: CHANGE_PAGINATION, offset, limit };
}

export function setPagination({ offset, limit }) {
  return { type: SET_PAGINATION, offset, limit };
}

export function setSearch(search) {
  return { type: SET_SEARCH, search };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/agents/SuppliersListView/index.js